<section class="section-title" [style.background-image]="backgroundImage">



  <div class="section-title-text">
    <h1 i18n="@@devices_title">Elenco dispositivi</h1>
  </div>

</section>

<section class="section-content">

  <div id="table-filter-container">
    <div class="table-filter">
      <input id="filter-input" (keyup)="onKey($event)" />
      <p i18n="@@devicelist_filter">Filtra: </p>
    </div>
  </div>

  <br clear="all" />

  <!-- <div class="buttons-container">
    <a (click)="addDevice()" class="button">
      <ng-container i18n="@@userslist_add_user">Aggiungi dispositivo</ng-container> <span>
        <fa-icon icon="user"></fa-icon>
      </span>
    </a>
  </div> -->




  <section id="devicesSection">


    <mat-tab-group id="tabGroup" [animationDuration]="'0ms'">

      <mat-tab id="listTab" label={{listString}}>

        <app-devices-list [deviceList]="deviceList" [filter]="filterString" (selected)="onDeviceSelected($event)"></app-devices-list>

      </mat-tab>

      <mat-tab id="mapTab" label={{mapString}}>

        <app-devices-map [deviceList]="deviceList" [filter]="filterString" (selected)="onDeviceSelected($event)"></app-devices-map>

      </mat-tab>

      <mat-tab *ngIf="isAdmin" id="activatedDevicesTab" label={{activatedDevicesString}}>

        <app-devices-activated [filter]="filterString" (selected)="onDeviceSelected($event)"></app-devices-activated>

      </mat-tab>

    </mat-tab-group>

  </section>

  <app-loading-screen #devicesloader></app-loading-screen>

</section>